// extracted by mini-css-extract-plugin
module.exports = {"angle":"Angle_angle__V3h8_","angle__svg":"Angle_angle__svg__F4URC"};